/* import __COLOCATED_TEMPLATE__ from './emoji-reactions.hbs'; */
/* RESPONSIBLE TEAM: team-omni */
import Component from '@glimmer/component';
import type { Reaction } from 'embercom/objects/inbox/reaction';
// @ts-ignore
import intermoji from '@intercom/intermoji';

interface Args {
  reactions: Reaction[];
  isUserPart: boolean;
}

interface Signature {
  Args: Args;
}

export default class EmojiReactions extends Component<Signature> {
  get hasReactions() {
    return this.args.reactions && this.args.reactions.length > 0;
  }

  get supportedReactions() {
    return this.args.reactions.filter((reaction) =>
      intermoji.unicodeFromIdentifier(reaction.emoji),
    );
  }

  get unsupportedReactions() {
    return this.args.reactions.filter(
      (reaction) => !intermoji.unicodeFromIdentifier(reaction.emoji),
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    EmojiReactions: typeof EmojiReactions;
    'emoji-reactions': typeof EmojiReactions;
  }
}
